var ics = require('./lib/ics.js');

module.exports = ics;


//////////////////
// WEBPACK FOOTER
// ./~/ics/index.js
// module id = 1049
// module chunks = 0